const hasBoldFontFile = (customFontFiles) => {
  return !!customFontFiles?.bold?.length;
};

const hasRegularFontFile = (customFontFiles) => {
  return !!customFontFiles?.regular?.length;
};

export const checkIsEmptyFontFile = (customFontFiles) => {
  return (
    !hasBoldFontFile(customFontFiles) && !hasRegularFontFile(customFontFiles)
  );
};

export const getCssFontSource = (fonts) => {
  return fonts
    .map((fontUrl) => {
      return `url(${fontUrl})`;
    })
    .join(',');
};
